import { render, staticRenderFns } from "./SeminarInvoice.vue?vue&type=template&id=03f072fe&"
import script from "./SeminarInvoice.vue?vue&type=script&lang=js&"
export * from "./SeminarInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports